/* eslint-disable import/prefer-default-export */
export const CHANGE_CURRENT_STEP = 'CHANGE_CURRENT_STEP'
export const SET_SERVICE_TYPES = 'SET_SERVICE_TYPES'
export const SET_EXTRA_INFOS = 'SET_EXTRA_INFOS'
// FOR LOCATIONS
export const UPDATE_LOCATION_ID = 'UPDATE_LOCATION_ID'
export const ORDER_LOCATION = 'ORDER_LOCATION'
export const OPTIMIZE_LOCATION = 'OPTIMIZE_LOCATION'
export const UPDATE_TMP_LOCATION = 'UPDATE_TMP_LOCATION'
export const CHECK_LOCATION_INFOS = 'CHECK_LOCATION_INFOS'
// FOR MAP
export const RENDER_DRIVER_MARKERS = 'RENDER_DRIVER_MARKERS'
// FOR BOOK AGAIN
// FOR EXTRA SERVICES
export const UPDATE_DISCOUNT_CODE = 'UPDATE_DISCOUNT_CODE'
export const UPDATE_DISCOUNT_CODE_STATUS = 'UPDATE_DISCOUNT_CODE_STATUS'
export const UPDATE_JOB_ORDER_NUMBER = 'UPDATE_JOB_ORDER_NUMBER'
export const UPDATE_OTHERS = 'UPDATE_OTHERS'
// FOR OUT OF SERVICE
// FOR CUSTOMER
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER'
export const IS_LOGIN_STEP_3 = 'IS_LOGIN_STEP_3'
// FOR CASHBACK
export const CALCULATE_CASHBACK = 'CALCULATE_CASHBACK'
export const RESET_CASHBACK_PERCENT = 'RESET_CASHBACK_PERCENT'
// FOR GENERAL VALUES
export const MIN_NUMBER_OF_LOCATIONS = 2
export const NOW = 'now'
export const SCHEDULE = 'schedule'
export const FULL_DAY = 'full_day'
export const QUICK_CHOICE = 'quick_choice'
export const MAX_SIZE_OF_FILE = 6000000 // 6mb
export const MAX_SIZE_OF_FILE_BEFORE_UPLOAD = 100000000 // 100mb
export const ATTACHMENT_FORMAT_TYPE = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg']
export const NOW_ENABLED_SETTING = 'immediate_enabled'

// FOR POPUP IDS (DOM)
export const POPUP_ID_SERVICE_TYPE_COMING_SOON = 'service-type-coming-soon-popup'
export const POPUP_ID_FULL_DAY_S1 = 'vehicle-type-full-day-s1-popup'
export const POPUP_ID_FULL_DAY_S2 = 'vehicle-type-full-day-s2-popup'
export const POPUP_ID_OUT_OF_SERVICE = 'out-of-service-popup'
export const POPUP_ID_EXTEND_SERVICE_AREA = 'extend-service-area-popup'

export const POPUP_ID_SERVICE_TYPE_POPUP_EYE = 'service-type-popup-eye-'
export const POPUP_ID_COD_INVOICE_FEE = 'cod-invoice-fees-'
export const POPUP_ID_EXTRA_SERVICE_POPUP_EYE = 'extra-service-popup-eye-'

// FOR POPUP TYPES
export const POPUP_TYPE_SERVICE_TYPE_POPUP_EYE = 'st_pe'
export const POPUP_TYPE_EXTRA_POPUP_EYE = 'es_pe'
export const POPUP_TYPE_EXTRA_POPUP_EYE_PACKAGE = 'es_pk_pe'
export const POPUP_TYPE_EXTRA_POPUP_EYE_FULL_DAY = 'es_fd_pe'
export const POPUP_TYPE_VEHICLE_TYPE_FULL_DAY_S1 = 'vt_fd_s1'
export const POPUP_TYPE_VEHICLE_TYPE_FULL_DAY_S2 = 'vt_fd_s2'

// FOR POPUP ITEM TYPE
export const ITEM_TYPE_SERVICE_TYPE_PE_TITLE = 'st_pe_title'
export const ITEM_TYPE_SERVICE_TYPE_PE_CONTENT = 'st_pe_content'
export const ITEM_TYPE_SERVICE_TYPE_PE_SIZE_TEXT = 'st_pe_size_text'
export const ITEM_TYPE_SERVICE_TYPE_PE_WEIGHT_TEXT = 'st_pe_weight_text'
export const ITEM_TYPE_EXTRA_PE_TITLE = 'es_pe_title'
export const ITEM_TYPE_EXTRA_PE_SUBTITLE = 'es_pe_subtitle'
export const ITEM_TYPE_EXTRA_PE_CONTENT = 'es_pe_content'
export const ITEM_TYPE_EXTRA_PE_CONTENT_LAST = 'es_pe_content_last'
export const ITEM_TYPE_EXTRA_PE_CONTENT_FINAL = 'es_pe_content_final'
export const ITEM_TYPE_VEHICLE_TYPE_FD_TITLE = 'vt_fd_title'
export const ITEM_TYPE_VEHICLE_TYPE_FD_SUBTITLE = 'vt_fd_subtitle'
export const ITEM_TYPE_VEHICLE_TYPE_FD_CONTENT = 'vt_fd_content'
export const ITEM_TYPE_VEHICLE_TYPE_FD_CONTENT_LONG = 'vt_fd_content_long'
export const ITEM_TYPE_VEHICLE_TYPE_FD_CONTENT_SMALL = 'vt_fd_content_small'

// FOR ELEMENT IDS
export const ID_RECIPIENT_NAME = 'recipient-name-'
export const ID_RECIPIENT_PHONE = 'recipient-phone-'
export const ID_NEW_SERVICE_TYPE = 'newServiceTypeId'
export const ID_NEW_VEHICLE_TYPE = 'newVehicleTypeId'

// FOR CONTACTS
export const ALLOW_DRIVER_TO_CALL = 'ALLOW_DRIVER_TO_CALL'
export const CLEAR_CUSTOMER_MASK_PHONE = 'CLEAR_CUSTOMER_MASK_PHONE'
export const CHECK_CUSTOMER_MASK_PHONE = 'CHECK_CUSTOMER_MASK_PHONE'

// FOR PREFERENCE DRIVER
export const DRIVER_PREFERENCES_POPUP = 'driver_preferences_popup'
export const DRIVER_PREFERENCES = {
  all: 'all',
  favorite: 'favorite',
  assign: 'assign',
  any: 'any',
  specific: 'specific',
  checked_favorite_driver_number: 5,
  banned: 'banned',
}
export const ASSIGNED_DRIVER_CONFLICT = {
  any_driver: 'ANY_DRIVER',
  favorite_driver: 'FAVORITE_DRIVER',
  specific_driver: 'SPECIFIC_DRIVER',
}
export const MAX_LENGTH_30_CHARACTER = 30
export const SHOW_3_DOTTED = '...'
export const ADD_FAVORITE_DRIVERS = 'ADD_FAVORITE_DRIVERS'
export const MAX_HEIGHT_VEHICLE_ICON = 54
export const MAX_CODE_VERIFY = 4

// Shopping List
export const SHOPPING_LIST_ITEM_STATUS = {
  // for new and edit booking
  waiting: 'waiting',
  editting: 'editting',
  pending: 'pending',
  not_available: 'not_available',
  confirmed: 'confirmed'
}
export const SHOPPING_LIST_STATUS = {
  // for new and edit booking
  locked: 'locked',
  not_locked: 'not_locked',
}
export const SHOPPING_FIELDS = ['credit_balance', 'has_upcoming_shopping_booking', 'bca_virtual_account', 'dlvr_bank_information']

// For ceb text edit mode
// For text of Color Banner
export const HIDE_WARNING_CALENDAR_BOOKING = 'HIDE_WARNING_CALENDAR_BOOKING'

// For Calendar Book
export const ADD_ID_CALENDAR = 'ADD_ID_CALENDAR'
export const REMOVE_ID_CALENDAR = 'REMOVE_ID_CALENDAR'
export const RESET_CALENDAR = 'RESET_CALENDAR'
export const UPDATE_CALENDAR = 'UPDATE_CALENDAR'

// For prev time type

// For tooltip
export const VISIBLE_CLASS = ' visible'
export const ERROR_DISTANCE_CLASS = ' dlvr-tooltip-error-distance'
export const FULL_DAY_MEGAZONE_CLASS = ' dlvr-tooltip-error-fd-megazone'
export const COMPLETED = 'completed'
export const CANCELED = 'canceled'

// For header
export const UPDATE_AREA_ID = 'UPDATE_AREA_ID'
export const UPDATE_ACTIVE_AREA = 'UPDATE_ACTIVE_AREA'
export const FREE_LABEL_KEY = 'webapp.label.free'

// For payment
export const PAY_BY_ONLINE_PAYMENT_LIST = ['pay_by_online_payment', 'pay_by_credit_and_online_payment']
export const DISABLED_PAYMENT_METHOD_STATUS = ['paid_by_credit_and_code', 'paid_by_credit', 'paid_by_code']